<div class="main-container">
  <div class="verification-content verification-title">
    <h1  appConfigSettingsTitle appConfigSettingsBackground>
      {{ "IdinVerificationErrorPage.Title" | translate }}
    </h1>
  </div>
  <mat-divider></mat-divider>
  <div class="verification-content-error" appConfigSettingsParagraph>
    <p>
      {{ "IdinVerificationErrorPage.ErrorMessage" | translate }}
    </p>
    <p>
      {{ "IdinVerificationErrorPage.TryAgainMessage" | translate }}
    </p>
  </div>
  <mat-divider></mat-divider>
  <div class="margin-above"></div>

  <div class="full-width buttonCenteredContainer button-center">
    <button mat-button appConfigSettingsButton (click)="calculationPage()">
      {{ "ThankYouPage.CalculationButton" | translate }}
    </button>
  </div>
</div>
